import { Warning } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import styled from 'styled-components';

/**
 * Console error overlay, used when pubnub becomes disconnected to prevent any user input
 */
const NetworkDisconnectedOverlay = () => {
    return (
        <Container>
            <Warning
                className="mb-xs"
                style="fill"
            />
            <BodyPrimary>
                <FormattedMessage id="disconnected_from_auction" />
            </BodyPrimary>
            <BodyPrimary>
                <FormattedMessage id="trying_to_reconnect" />
            </BodyPrimary>
        </Container>
    );
};

export default NetworkDisconnectedOverlay;

const Container = styled.div`
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: ${({ theme }) => theme.colors.shadowOverlayRed100};
    z-index: 100;
`;
